import React, { Component } from 'react';
import Navbar from "../NAV/Navbar";
import ParticlesBg from "particles-bg";
import {Grid,Typography} from "@material-ui/core";
import "./portf.css";
import portfolioItems from './portflio-items';
import { toElement as scrollToElement } from './utils';

let mainColor="#00bcd4"
class PortfolioPage extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
        this.scrollToNext=this.scrollToNext.bind(this);
    }
    scrollToNext(ele) {
        console.log(ele);
        let y=document.querySelector(ele);
        scrollToElement(y);
      }
    render() { 
        let config = {
            num: [4, 7],
            rps: 0.1,
            radius: [5, 40],
            life: [1.5, 3],
            v: [1, 2],
            tha: [-40, 40],
            alpha: [0.6, 0],
            scale: [.1, .1],
            position: "all",
            color: [mainColor],
            cross: "dead",
            // emitter: "follow",
            random: 10
          };
          if (Math.random() > 0.85) {
            config = Object.assign(config, {
              onParticleUpdate: (ctx, particle) => {
                ctx.beginPath();
                ctx.rect(
                  particle.p.x,
                  particle.p.y,
                  particle.radius * 2,
                  particle.radius * 2
                );
                ctx.fillStyle = particle.color;
                ctx.fill();
                ctx.closePath();
              }
            });
          }
        return ( 
            <div className="parallax">
                <Navbar color="#ffffff" tcolor="#00bcd4"/>
                <Grid container style={{color:mainColor,fontFamily:`system-ui`}}>
                    <Grid id="element1" item container style={{height:"92vh",width:"100vw",textAlign:"center",display: 'flex',alignItems: 'center',justifyContent: 'center'}}>
                        <Grid item style={{paddingTop:"15vh"}}><div><b style={{fontSize:"4em",fontFamily:`system-ui`}}>Hello, I'm Ujjwal</b></div>
                        <div><Typography style={{fontSize:"2em",fontFamily:`system-ui`}}>Full Stack Developer | Deep Learning Enthusiast | Competitive Coder</Typography></div>
                        <div style={{fontSize:"3em"}}><a target="_blank" rel="noopener noreferrer" href="https://github.com/shadowshot-x" style={ { color: mainColor,paddingRight:"2vw" } }><i className="fa fa-github"></i></a>
        <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/ujjwal-sharma-b1066414b/" style={ { color: mainColor ,paddingRight:"2vw"} }><i className="fa fa-linkedin"></i></a>
        <a target="_blank" rel="noopener noreferrer" href="https://leetcode.com/ujjwal26599/" style={ { color: mainColor ,paddingRight:"2vw"} }><i className="fa fa-code"></i></a>
        <a target="_blank" rel="noopener noreferrer" href="https://medium.com/@ujjwal26599" style={ { color: mainColor,paddingRight:"2vw" } }><i className="fa fa-medium"></i></a>
        <a target="_blank" rel="noopener noreferrer" href="https://www.hackerrank.com/ujjwal26599" style={ { color:mainColor,paddingRight:"2vh" } }><b><i>Hr</i></b></a></div>
                        </Grid>
                        <Grid item xs={12} style={{paddingTop:"15vh"}}>
                            <div onClick={()=>this.scrollToNext("#element2")}><i class="fa fa-angle-double-down" aria-hidden="true" style={{fontSize:"3em"}}></i></div>
                            </Grid>

                    </Grid>
                    <Grid id="element2" item style={{height:"100%",width:"100vw",fontFamily:`system-ui`,paddingLeft:"10vw",paddingRight:"10vw",paddingTop:"25vh",backgroundColor:mainColor}}>
                    <div className="about-page">
      <div className="content-grid">
        <h1 style={{ color:"white",fontSize:"3em" }}><b id="firstInsideContainer">About</b></h1>
        <div className="about-wrapper">
          <div className="about-content" style={{color:"white",fontSize:"1.5em" }}>
            <p>
              I Love <span className="highlight">Web Development</span>, Deep Learning and Problem Solving.I beleive combining all of these together to provide the best Softwares possible. 
            </p>
            <p>
              When my dev senses kick-in I build presumably{' '}
              <span className="highlight"> awesome stuff</span>. I stay close to
              the community and try to keep tabs with the pace at which my environment
              is evolving. I also like to{' '}
              <span className="highlight">apply</span> what I learn.
            </p>
            <p>
              I built this site <span className="highlight">from scratch</span>.
              I love to provide Technical Insights and <i>Help Others through their Dev journey.</i>{' '}) and I try to have fun along the way.
            </p>
            <p>
              React-Redux, Node.js, Java,Python are a few tricks up my sleeve. I have also started my journey towards Artificial Intelligence and Deep Learning.
            </p>
            <p className="text-emoji" style={{ color:"white" }}>
              \ (•◡•) /
            </p>
          </div>
        </div>
      </div>
    </div>
    <Grid item xs={12} style={{paddingTop:"15vh",display: 'flex',alignItems: 'center',justifyContent: 'center'}}>
                            <div onClick={()=>this.scrollToNext("#element3")}><i class="fa fa-angle-double-down" aria-hidden="true" style={{fontSize:"3em",color:"white"}}></i></div>
                            </Grid>
                    </Grid>
                    <Grid id="element3" item style={{height:"100%", width:"100vw",paddingLeft:"10vw",paddingRight:"10vw",paddingTop:"10vh",paddingBottom:"10vh"}}>
                    <div className="portfolio-page">
      <div className="content-grid">
        <h1 style={{ color: mainColor }}><b>Portfolio</b></h1>
        <div className="portfolio-wrapper">
          <style jsx="true">
            {`
              .portfolio-item {
                background-color: ${mainColor};
                color: ${"#ffffff"};
              }
              .portfolio-item a {
                color: ${"#ffffff"};
              }
              .portfolio-item__links a:hover {
                border-bottom: 2px solid ${"#ffffff"};
              }
            `}
          </style>
          <Grid container spacing={3}>
          {portfolioItems.map((item, i) => (
            <Grid item xs={6} md={3}>{item.render}</Grid>
          ))}
          </Grid>
        </div>
      </div>
    </div>
                    </Grid>
                </Grid>
                <ParticlesBg type="custom" config={config} className="bubbles" bg={true} />
    </div>
    
         );
    }
}
 
export default PortfolioPage;


// WEBPACK FOOTER //
// ./src/components/PORTFOLIO/PortfolioPage.js